import { Box } from '@mui/material';
import { AppBar } from '../components/AppBar';
import { Hero } from '../components/landing/Hero';
import { AcceptsPlate } from '../components/landing/AcceptsPlate';
import { WhyStorefront } from '../components/landing/WhyStorefront';
import { Toolkit } from '../components/landing/Toolkit';
import { AnalystsAgents } from '../components/landing/AnalystsAgents';
import { EvidenceGraded } from '../components/landing/EvidenceGraded';
import { Pricing } from '../components/landing/Pricing';
import { Footer } from '../components/landing/Footer';

export function Landing() {
  return (
    <Box>
      <AppBar />
      <Box component="main">
        <Hero />
        <AcceptsPlate />
        <WhyStorefront />
        <Toolkit />
        <AnalystsAgents />
        <EvidenceGraded />
        <Pricing />
      </Box>
      <Footer />
    </Box>
  );
}
